import { PENDO_IGNORE } from '@/analytics/domPrivacy'
import { isExagoReportId } from './jobIdentity'

/**
 * Spec 216 — text that names an Advanced (Exago) report or its schedule, kept out of Pendo.
 *
 * For an `exago/` id the text is wrapped in a PENDO_IGNORE span; for every other report it
 * is returned exactly as given, with no element added, so a non-Exago string still reads as
 * one text node (several tests find these by their whole text).
 */
const FirmText = ({ reportId, children }) => (
  isExagoReportId(reportId) ? <span className={PENDO_IGNORE}>{children}</span> : children
)

export default FirmText
